<template>
  <p class="AnnouncementContentTextCaption">
    <slot />
  </p>
</template>

<script>
export default {
  name: 'AnnouncementContentTextCaption',
  emits: ['click'],
}
</script>

<style lang="scss">
.AnnouncementContentTextCaption {
  @include caption;
  color: $color-black-medium;
  margin: 0;
}
</style>
